<template>
    
</template>

<script>
    export default {
        name: "CardActionsMixin",
        methods: {
            getCardClickAction () {
                return this.myData.onClickAction;
            },
            setCardClickAction (eventData) {
                this.changeMyData({
                    onClickAction: eventData.value
                })
                this.setChangesAreSaved(false);
            },
            getCardOpenTarget () {
                return this.myData.openWithTarget;
            },
            setCardOpenTarget (eventData) {
                this.changeMyData({
                    openWithTarget : eventData.value
                })
                this.setChangesAreSaved(false);
            },
        }
    }
</script>

